import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.unit.Density
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.window.CanvasBasedWindow
import com.arkivanov.decompose.DefaultComponentContext
import com.arkivanov.decompose.ExperimentalDecomposeApi
import com.arkivanov.decompose.router.stack.webhistory.DefaultWebHistoryController
import com.arkivanov.essenty.lifecycle.LifecycleRegistry
import com.arkivanov.essenty.lifecycle.destroy
import com.arkivanov.essenty.lifecycle.resume
import com.arkivanov.essenty.lifecycle.stop
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.skiko.wasm.onWasmReady
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.events.Event
import org.w3c.dom.events.EventListener
import tta.destinigo.talktoastro.core.di.initKoin
import tta.destinigo.talktoastro.core.navigation_decompose.root_component.DefaultRootComponent
import tta.destinigo.talktoastro.core.navigation_decompose.web_history_controller.DeepLink
import tta.destinigo.talktoastro.core.navigation_decompose.web_history_controller.getPathAndSlug
import tta.destinigo.talktoastro.shared.persentation.LocalLayerContainer

const val META_TAG_TITLE = "TalktoAstro - Online Astrology"
private var rootComponentInstance: DefaultRootComponent? = null

@OptIn(
    ExperimentalComposeUiApi::class,
    ExperimentalDecomposeApi::class,
    ExperimentalComposeUiApi::class
)
fun main() {
    val META_TAG_DESCRIPTION = """
        Unlock your future with a personalized astrology consultation. Talk to astrologer on relationships, 
        career, and life path through birth chart analysis. Book now for clarity and cosmic guidance.
    """.trimIndent()

    // Update Meta Tags
    fun updateMetaTags(title: String, description: String) {
        document.title = title
        val metaDescription =
            document.querySelector("meta[name='description']") ?: document.createElement("meta")
                .apply {
                    setAttribute("name", "description")
                    document.head?.appendChild(this)
                }
        metaDescription.setAttribute("content", description)
    }

    updateMetaTags(META_TAG_TITLE, META_TAG_DESCRIPTION)

    // Initialize Koin
    initKoin()

    // Lifecycle setup
    val lifecycleRegistry = LifecycleRegistry()
    lifecycleRegistry.attachToDocument()

    val skeletonLoader = document.getElementById("skeleton-loader") as? HTMLDivElement
    skeletonLoader?.style?.display = "block"

    //    val skeletonLoader = document.getElementById("skeleton-loader") as? HTMLDivElement
//    skeletonLoader?.style?.display = "block"

    onWasmReady {
        // Clamp devicePixelRatio for Safari
        val clampedDpr = window.devicePixelRatio.toFloat().coerceIn(1f, 4f)
        var density by mutableStateOf(Density(clampedDpr))

        // Listen to resize
        window.addEventListener("resize", {
            density = Density(window.devicePixelRatio.toFloat().coerceIn(1f, 2f))
        })

        val prefersDarkTheme = window.matchMedia("(prefers-color-scheme: dark)").matches

        // Defer rendering to avoid Safari blocking
        MainScope().launch {
            delay(200) // Give WASM thread some breathing time

            // Create rootComponent only once
            if (rootComponentInstance == null) {
                rootComponentInstance = DefaultRootComponent(
                    componentContext = DefaultComponentContext(lifecycle = lifecycleRegistry),
                    deepLink = DeepLink.Web(path = getPathAndSlug(window.location.href)),
                    webHistoryController = DefaultWebHistoryController()
                )
            }

            skeletonLoader?.style?.display = "none"

            CanvasBasedWindow(
                title = META_TAG_TITLE,
                canvasElementId = "app-canvas-21.52.50" // Use <canvas id="app-canvas" />
            ) {
                CompositionLocalProvider(
                    LocalDensity provides density,
                    LocalLayoutDirection provides LayoutDirection.Ltr,
                    LocalLayerContainer provides LocalLayerContainer.current
                ) {
                    App(
                        darkTheme = prefersDarkTheme,
                        dynamicColor = true,
                        rootComponent = rootComponentInstance!!
                    )
                }
            }
        }
    }
}

private fun LifecycleRegistry.attachToDocument() {
    println("Lifecycle: onCreate")
    // Simulating onCreate (just once at app start)

    // Simulating onStart + onResume when window is visible
    fun onVisibilityChanged() {
        val visibilityState = document.asDynamic().visibilityState as String
        if (visibilityState == "visible") {
            println("Lifecycle: onStart -> onResume")
            resume()
        } else {
            println("Lifecycle: onPause -> onStop")
            stop()
        }
    }

    // Simulating onDestroy
    val unloadListener = EventListener {
        println("Lifecycle: onDestroy")
        destroy()
    }

    onVisibilityChanged()

    // Listen to visibility changes
    document.addEventListener("visibilitychange", { _: Event ->
        onVisibilityChanged()
    })

    // Listen to page unload
    window.addEventListener("beforeunload", unloadListener)
    window.addEventListener("unload", unloadListener)
}


//// Constants for meta tags
//const val META_TAG_TITLE = "TalktoAstro - Online Astrology"
//
//@OptIn(ExperimentalComposeUiApi::class, ExperimentalDecomposeApi::class)
//fun main() {
//
//    val META_TAG_DESCRIPTION = """
//        Unlock your future with a personalized astrology consultation. Talk to astrologer on relationships,
//        career, and life path through birth chart analysis. Book now for clarity and cosmic guidance.
//    """.trimIndent()
//
//    // Update Meta Tags
//    fun updateMetaTags(title: String, description: String) {
//        document.title = title
//        val metaDescription = document.querySelector("meta[name='description']")
//            ?: document.createElement("meta").apply {
//                setAttribute("name", "description")
//                document.head?.appendChild(this)
//            }
//        metaDescription.setAttribute("content", description)
//    }
//
//    updateMetaTags(META_TAG_TITLE, META_TAG_DESCRIPTION)
//
//    // Initialize Koin
//    initKoin()
//
//    // Lifecycle setup
//    val lifecycleRegistry = LifecycleRegistry()
//    lifecycleRegistry.attachToDocument()
//
//    // Root component setup
//    val rootComponent = DefaultRootComponent(
//        componentContext = DefaultComponentContext(lifecycle = lifecycleRegistry),
//        deepLink = DeepLink.Web(path = getPathAndSlug(window.location.href)),
//        webHistoryController = DefaultWebHistoryController()
//    )
//
//    // Dark theme detection
//    val prefersDarkTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
//
//    // Density state setup
//    var density by mutableStateOf(Density(window.devicePixelRatio.toFloat()))
//    window.addEventListener("resize", { density = Density(window.devicePixelRatio.toFloat()) })
//
//    val skeletonLoader = document.getElementById("skeleton-loader") as? HTMLDivElement
//    skeletonLoader?.style?.display = "block"
//
//
//    // Main window setup
//    onWasmReady {
//
//        // Hide skeleton loader
//        skeletonLoader?.style?.display = "none"
//
//        CanvasBasedWindow(title = META_TAG_TITLE) {
//            CompositionLocalProvider(
//                LocalDensity provides density,
//                LocalLayoutDirection provides LayoutDirection.Ltr,
//                LocalLayerContainer provides LocalLayerContainer.current
//            ) {
//                App(
//                    darkTheme = prefersDarkTheme,
//                    dynamicColor = true,
//                    rootComponent = rootComponent
//                )
//            }
//        }
//    }
//}
//
//
//
//private fun LifecycleRegistry.attachToDocument() {
//
//    val visibilityState = document.asDynamic().visibilityState as String
//    fun onVisibilityChanged() {
//        if (visibilityState == "visible") {
//            resume()
//        } else {
//            stop()
//        }
//    }
//
//    onVisibilityChanged()
//        document.addEventListener("visibilitychange", { _: Event ->
//        onVisibilityChanged()
//    })
//}


